import { render, staticRenderFns } from "./AntonellaAutor.vue?vue&type=template&id=505080b7&scoped=true"
import script from "./AntonellaAutor.vue?vue&type=script&lang=js"
export * from "./AntonellaAutor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505080b7",
  null
  
)

export default component.exports